import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WifidetailsRoutingModule } from './wifidetails-routing.module';
import { WifidetailsComponent } from './wifidetails.component';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [WifidetailsComponent],
  imports: [
    CommonModule,
    NgbModule,
    WifidetailsRoutingModule,
    CommonModule,      
        
        SharedModule,
       
        ReactiveFormsModule
  ]
})
export class WifidetailsModule { }
